import angular from 'angular';
import template from './participant-video-frame-full.html';
import groupCallMobileDoctorActions from './actions/group-call/mobile-doctor-actions/mobile-doctor-actions';
import groupCallMobilePatientActions from './actions/group-call/mobile-patient-actions/mobile-patient-actions';
import oneToOneCallMobileDoctorActions from './actions/one-to-one/mobile-doctor-actions/mobile-doctor-actions';
import oneToOneCallMobilePatientActions from './actions/one-to-one/mobile-patient-actions/mobile-patient-actions';
import brandedLogo from '../../elements/call-frames-branded-logo/call-frames-branded-logo';
import * as call from '../../../../modules/call';
import * as localMedia from '../../../../modules/local-media';
class ParticipantVideoFrameController {
    constructor($element, VideoProviderFactory, VideoProviderHelper, participantVideoFrameService, downgradeCallStateService, $timeout, $scope, $ngRedux) {
        this.$element = $element;
        this.VideoProviderFactory = VideoProviderFactory;
        this.VideoProviderHelper = VideoProviderHelper;
        this.participantVideoFrameService = participantVideoFrameService;
        this.downgradeCallStateService = downgradeCallStateService;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$ngRedux = $ngRedux;
        this.callPublisherErrorVariant = call.constants.CallFrameVariant.Full;
        this.unsubscribeFromStore = this.$ngRedux.connect((state) => this.mapStateToThis(state))(this);
    }
    $onInit() {
        this.$scope.$watch('$ctrl.withVideo', () => {
            if (!this.withVideo) {
                return;
            }
            void this.participantVideoFrameService.updateVideo(this.stream, this.$element[0]);
            void this.participantVideoFrameService.setPreferredResolutionToFull(this.stream);
        });
        void this.$timeout(() => {
            this.shouldFitVideo =
                this.VideoProviderHelper.getFitMode(this.stream.id) === 'contain';
        });
        this.$scope.$watch(() => this.downgradeCallStateService.isShownDowngradeFrame(), (isShownDowngradeFrame) => {
            if (isShownDowngradeFrame) {
                this.screen = this.stream.getImgData() || this.avatarPicture;
            }
        });
    }
    get activeVideoProvider() {
        return this.VideoProviderFactory.activeProvider;
    }
    mapStateToThis(state) {
        return {
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
            isPiPTurnedOn: call.selectors.isPiPTurnedOn(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const participantVideoFrameComponent = {
    template,
    bindings: {
        withVideo: '<',
        stream: '<',
        username: '<',
        placeholder: '<',
        onCallEnd: '&',
        disabled: '<',
        onToggleAudio: '&',
        isVideoDisabled: '<',
        isInGroupCall: '<',
        avatarPicture: '<',
        videoSubscriberId: '<',
        onSelect: '&',
        isPinned: '<',
        isPatient: '<',
        hasPublisherError: '<',
    },
    controller: ParticipantVideoFrameController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrameFullComponent', [
    groupCallMobileDoctorActions,
    groupCallMobilePatientActions,
    oneToOneCallMobileDoctorActions,
    oneToOneCallMobilePatientActions,
    brandedLogo,
])
    .component('participantVideoFrameFull', participantVideoFrameComponent).name;
